import { render } from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=template&id=0dd3ffa6&scoped=true"
import script from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=script&lang=js"
export * from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=script&lang=js"

import "./ConsentDoubleOptinConfirmationPage.vue?vue&type=style&index=0&id=0dd3ffa6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd3ffa6"]])

export default __exports__